<template>
  <div>
    <div class="comm_popup_wrap_large">
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_TRM_NM')" :vertical="false" />
          </div>
          <div class="col-xs-5">
            <sui-text-field placeholder="" v-model= "frame0.termName" 
            @keyup="onKeyUpInput($event,'termName')"
              @keyup.enter="sourceTermList"
              default value :disabled="false" :clearable="true" :readonly="false"></sui-text-field>
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_TRM_PHSC_NM')" :vertical="false" />
          </div>
          <div class="col-xs-5">
            <sui-text-field placeholder="" v-model= "frame0.termPhyName"
            @keyup="onKeyUpInput($event,'termPhyName')"
              @keyup.enter="sourceTermList"
               default value :disabled="false" :clearable="true" :readonly="false"></sui-text-field>
          </div>
       </div>
        <div class="btn_wrap">
          <sui-button type="button" class="comm_btn_Reset" @click="onReset()" v-permission:read="'PGE_CMT_00004'">{{$t('MSG_BTN_RESET')}}</sui-button>
          <sui-button type="button" class="comm_btn_Scr" @click="sourceTermList()" v-permission:read="'PGE_CMT_00004'" >{{$t('MSG_BTN_SEARCH')}}</sui-button>
        </div>
      </div>
      <div class="mrB30"></div>
      <sui-grid ref="grid" :columns="gridColumns0" :dataset="'dataset0'"
            :hideHeader="false"
            :autoheight= "false"
            :multiselect="false"
            :pageable="false"
            :showCountControl="true"
            :showDisplayCountControl="false"
            :initial-pagesize="10"
            :pagesizeoptions="[1]"
            @rowselect="onClickWordRow($event)"
            >
      </sui-grid>
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button type="button" class="comm_btn_border"  @click="onCancel()">{{$t('MSG_BTN_CANCEL')}}</sui-button>
      <sui-button type="button" class="comm_btn_solid" @click="selectSourceTerm()" v-permission:read="'PGE_CMT_00004'">{{$t('MSG_BTN_SELT')}}</sui-button>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'PGE_CMT_00004_P05',
    data() {
      return {
        selectedCodeValue: {
          COD_MDLE: {
            label: '',
            key: ''
          }
        },
        frame0 :{
        termName:'',
        termPhyName:'',
        },
        selectedSourceTerm:'',
        localdata0: [],
        gridColumns0: [{
          text: this.$t('MSG_TXT_TRM_NM'),
          datafield: 'termsName'
        }, {
          text: this.$t('MSG_TXT_TRM_PHSC_NM'),
          datafield: 'termsId',
          width: 200,
        }, {
          text: this.$t('MSG_TXT_TRM_DSCR'),
          datafield: 'termsContent'
        }, {
          text: this.$t('MSG_TXT_DOMAIN_NAME'),
          datafield: 'domainName',
          width: 180,
        }],
      };
    },
    computed: {},
    watch: {},
    // datasets: [],
    mounted() {},
    beforeUpdate() {},
    updated() {},
    beforeDestroy() {},
    destroyed() {},
    methods: {
      sourceTermList() {
        const queryParams = {
        termName: this.termName || '',
        termId: this.termPhyName || '',
      };
      http.request('PGE_CMT_00004', 'DTS_CMT_00033', {
        query: queryParams,
      }).then(res => {
        console.log(res)
          this.dataset0.setRawData(res.data);
      });
      },
      onCancel() {
        this.$emit('exit', true);
      },
      onReset() {
        this.frame0.termName = '';
        this.frame0.termPhyName = '';
      },
       onKeyUpInput(event, name) {
      const searchFieldNewText = this.frame0[name];
      if (utils.isExistSpecialChar(searchFieldNewText)) {
        utils.messageBox('warning', this.$t('MSG_ALT_NO_SPECL_CHAR'), null, () => {
          this.frame0[name] = this[name];
          //this.$refs[name].setFocus();
        });
      } else {
        this[name] = searchFieldNewText;
      }
    },
      onClickWordRow(e) {
          this.selectedSourceTerm = {
            'termName' : e.args.row.termsName,
            'termId' : e.args.row.termsId,
            'termsContent': e.args.row.termsContent,
            'domainDesc' : e.args.row.domainDecription,
            'domainName' : e.args.row.domainName,
            'domainLength': e.args.row.domainLength,
            'domainDataDecimalLength' : e.args.row.domainDataDecimalLength,
            'domainDataTypeName' : e.args.row.domainDataTypeName,
          }
      },
      selectSourceTerm() {
        this.$emit('sourceTermPopulate',this.selectedSourceTerm);
        this.onCancel();
      },
    },
    datasets: [{
      id: 'dataset0',
      type: 'local',
      data: 'localdata0',
      datafields: [{
        name: 'termsName',
        type: 'string',
        map: 'termsName'
      }, {
        name: 'termsId',
        type: 'string',
        map: 'termsId'
      }, {
        name: 'termsContent',
        type: 'string',
        map: 'termsContent'
      }, {
        name: 'domainName',
        type: 'string',
        map: 'domainName'
      }, {
        name: 'domainDecription',
        type: 'string',
        map: 'domainDecription'
      },{
        name: 'domainDataTypeName',
        type: 'string',
        map: 'domainDataTypeName'
      }      ,{
        name: 'domainDataDecimalLength',
        type: 'string',
        map: 'domainDataDecimalLength'
      },{
        name: 'domainLength',
        type: 'string',
        map: 'domainLength'
      }]
    }],
  };
</script>
<style scoped>
</style>
